<script setup lang="ts">
import MmIcon from './MmIcon.vue'
import type { MmIconName } from './icons'
const props = withDefaults(defineProps<{
  label: string
  summary?: string
  open?: boolean
  icon?: MmIconName
  variant?: 'card' | 'divider'
  nested?: boolean
  titleTag?: 'strong' | 'h2' | 'h3'
  collapseBelow?: number
}>(), { open: false, variant: 'card', nested: false, titleTag: 'strong' })
const emit = defineEmits<{ 'update:open': [value: boolean] }>()
const element = ref<HTMLDetailsElement | null>(null)
const wide = ref(true)
let media: MediaQueryList | undefined
const updateWidth = () => { wide.value = media?.matches ?? true }
onMounted(() => {
  if (!props.collapseBelow) return
  media = window.matchMedia(`(min-width: ${props.collapseBelow}px)`)
  updateWidth()
  media.addEventListener('change', updateWidth)
})
onBeforeUnmount(() => media?.removeEventListener('change', updateWidth))
defineExpose({ element })
</script>

<template>
  <details ref="element" class="disclosure" :class="{ 'disclosure-divider': variant === 'divider', 'disclosure-nested': nested }" :open="open && wide" @toggle="emit('update:open', ($event.target as HTMLDetailsElement).open)">
    <summary>
      <span v-if="icon || $slots.icon" class="disclosure-icon"><slot name="icon"><MmIcon :name="icon!" :size="20" /></slot></span>
      <span class="summary-text">
        <slot name="title"><component :is="titleTag" class="disclosure-title">{{ label }}</component></slot>
        <small v-if="summary || $slots.summary"><slot name="summary">{{ summary }}</slot></small>
      </span>
      <MmIcon name="down" class="chev" :size="20" />
    </summary>
    <div class="body"><slot /></div>
  </details>
</template>
